export const abc = "test";
export const DATE_FORMAT = "MM-DD-YYYY";
export const DATE_TIME_FORMAT = "MM-DD-YYYY h:m A";
export const MASTER_DROPDOWN_PAGE_SIZE = 30;
export const PAGE_SIZE = 15;

export const LOOKUP_TYPE = {
    PRODUCT_STATUS: 10,
    PRODUCT_TYPE: 12,
    RETURN_PERIOD: 11,
    ACCURACY: 36,
    MARKUP_MARGIN: 15,
    INVENTORY_STATUS: 39,
    DIMENSION_UNITS: 14,
    ADDRESS_TYPE: 8,
    CONTACT_TYPE: 7,
    LEAD_TIME_BY: 6,
    PO_RECEIVING_METHOD: 5,
    PER_BOX_TYPE: 40,
    GENDER: 23,
    CUSTOMER_TYPE: 22,
    CUSTOMER_GROUP_TYPE: 49,
    DISCOUNT_TYPE: 13,
    DISCOUNT_MIN_PURCHASE_AMOUNT: 41,
    DISCOUNT_MAX_ALLOWED: 42,
    DISCOUNT_USAGE_LIMIT: 43,
    DISCOUNT_COMBINATION: 44,
    DISCOUNT_MODE: 45,
    DISCOUNT_TARGET_CUSTOMER: 46,
    DISCOUNT_PRODUCT_ROLE: 48,
    CUSTOMER_GROUP_SCHEDULE_FREQUENCY: 52,
    CUSTOMER_GROUP_CHANNELS: 53,
    // COMMISSION_TYPE: 13,
    LOYALTY_EXPIRY: 74,
    LOYALTY_TYPE: 57,
    LOYALTY_DISCOUNT_TYPE: 56,
    REWARD_TYPE: 55,
    PROGRAM_CATEGORY: 58,
    SCHEDULE_COUNT_TYPE: 51,
    RETURN_STATUS: 59,
    RETURN_METHOD: 60,
    PO_STATUS: 62,
    RECEIVE_ORDER_STATUS: 67,
    RECEIVE_ORDER_REASONS: 68,
    SETUP_RETURN_REFUND_METHOD: 71,
    SETUP_RETURN_SHIPPING_COST: 72,
    SETUP_RETURN_RESTOCKING_FEE: 73,
    ACTION_TYPE: 76,
    PUNCH_TYPE: 75,
    ROLE_APPLICATION_TYPE: 70,
    GIFT_CARD_TYPE: 77,
    ACTIVATION_KEY_TYPE: 78,
    ORDER_STATUS: 24,
    LOCATION_TYPE: 20,
    LOCATION_STATUS: 2,
    RESTOCK_REASON:85,
    MEASURED_BY:90,
    LOTTERY_TICKET_TYPE:93,
    TRANSFER_STATUS: 64,
    VOID_REASON: 100,
    FRAME_TYPE: 101,
    RECEIPT_PAYMENT_TYPE: 103,
    PRICE_TYPE: 104,
    
    RESTRICTED_SCHEDULE_TYPE: 105,
    RESTRICTED_PRODUCT_TYPE: 106,
    REFUND_STATUS: 107,
};

// Specific lookupId values within a LOOKUP_TYPE, for branching on a particular
// option (e.g. "Custom" return period) instead of matching its display label,
// which breaks once labels are localized.
export const LOOKUP_VALUE = {
    PRODUCT_TYPE_STANDARD: 44,
    PRODUCT_TYPE_VARIANT: 45,
    PRODUCT_TYPE_BUNDLE: 46,
    PRODUCT_TYPE_GIFT_CARD: 219,
    RETURN_PERIOD_CUSTOM: 43,
    MEASURED_BY_COUNT: 258,
    MEASURED_BY_WEIGHT: 259,
    PRODUCT_STATUS_ACTIVE: 33,
    RESTRICTED_PRODUCT_TYPE_NONE: 314,
    PER_BOX_TYPE_QUANTITY: 123,
    PER_BOX_TYPE_WEIGHT: 124,
    RECEIPT_PRICE_DISPLAY_SINGLE: 305,
    LOYALTY_DISCOUNT_TYPE_PERCENTAGE: 162,
    LOYALTY_DISCOUNT_TYPE_DOLLAR: 163,
    LEAD_TIME_DAYS: 21,
    LEAD_TIME_WEEKS: 22,
    LEAD_TIME_MONTHS: 23,
    LEAD_TIME_YEARS: 24,
    RECEIVE_ORDER_REASON_DAMAGED: 198,
    PUNCH_TYPE_SHIFT_START: 220,
    PUNCH_TYPE_SHIFT_END: 221,
    PRICE_TYPE_CASH: 308,
    PRICE_TYPE_CARD: 309,
    PRICE_TYPE_NONE: 307,
    INVENTORY_STATUS_OVER_STOCK: 120,
    MARKUP_MARGIN_FIXED: 56,
    MARKUP_MARGIN_PERCENTAGE: 57,
    ACTIVATION_KEY_TYPE_FIXED: 226,
    ACTIVATION_KEY_TYPE_PERCENTAGE: 227,
    FRAME_TYPE_SQUARE: 299,
    FRAME_TYPE_RECTANGLE: 300,
    NOTIFICATION_REMINDER_TYPE_EMAIL: 228,
    NOTIFICATION_REMINDER_TYPE_TEXT: 229,
    REFUND_METHOD_STORE_CREDIT: 206,
    RECEIVE_ORDER_STATUS_RECEIVED: 194,
    RESTOCK_REASON_REFURBISHED: 242,
    RESTOCK_REASON_SENT_TO_REPAIR: 244,
    SCHEDULE_COUNT_TYPE_PARTIAL: 149,
    SCHEDULE_COUNT_TYPE_FULL: 150,
    PO_RECEIVING_METHOD_EMAIL: 17,
    PO_RECEIVING_METHOD_ONLINE: 19,
    DISCOUNT_MODE_SHIPPING_DISCOUNT: 138,
    GIFT_CARD_TYPE_EGIFT: 224,
    GIFT_CARD_TYPE_PHYSICAL: 225,
};

export const addressType = {
    physical: 27,
    mailing: 28,
    postal: 235,
};

export const contactType = {
    primary: 25,
    secondary: 26,
};

export const customerTypeEnum = {
    individual: 74,
    business: 75,
};

export const schedulerFrequecyEnum = {
    Daily: "Day",
    Weekly: "Week",
    Monthly: "Month",
    Quaterly: "Quater",
    Yearly: "Year",
};

export const accuracyOptions = [
    { value: "0", label: "0" },
    { value: ".0", label: ".0" },
    { value: ".00", label: ".00" },
    { value: ".000", label: ".000" },
];

export const conditionOptions = [
    { value: "LT", label: "Less than" },
    { value: "GT", label: "Greater than" },
    { value: "EQ", label: "Equal to" },
];

export const productTypes: any = {
    standard: "Standard Product",
    variant: "Variant Product",
    bundle: "Bundle Product",
    "physical-gift-card": "Physical Gift Card",
};

export const displayOnMenuOptions = [
    // { value: "0", label: "Displayed on Both POS and Online Store" },
    { value: "1", label: "Displayed on POS" },
    { value: "2", label: "Displayed on Online Store" },
];

export const labelPrinterFormats = [
    { lookupId: "233", lookupValue: "Continuous feed (wide)" },
]

export const embeddedBarcodes = [
    { lookupId: "234", lookupValue: "Only allow SKUs" },
]

export const locationType = {
    store: 67,
    warehouse: 68,
};

export const punchType = {
    shiftStart: 220,
    shiftEnd: 221,
};
